var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4517 0.966499C13.712 1.22685 13.712 1.64896 13.4517 1.90931L5.43778 9.92318L1.19514 5.68054C0.934791 5.42019 0.934791 4.99808 1.19514 4.73773C1.45549 4.47739 1.8776 4.47739 2.13795 4.73773L5.43778 8.03757L12.5088 0.966499C12.7692 0.706149 13.1913 0.706149 13.4517 0.966499Z",
    fill: "#004996",
    stroke: "#004996",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveCheck);
export default __webpack_public_path__ + "static/media/ApproveCheck.56640af556824f35274811147d4f06b3.svg";
export { ForwardRef as ReactComponent };